import { createReducer } from 'store/utils';
import { RootActions } from 'store/types';
import { actionsHandlers, stateFactories } from 'store/features/utils';
import * as actions from './actions';

const stateFactory = stateFactories.createInitialSingleFeatureStateFactory();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

const accountReducer = createReducer<State, Actions>(initialState, {
  [actions.deleteAccount.request.type]: actionsHandlers.handleSingleFeatureRequest,
  [actions.deleteAccount.success.type]: actionsHandlers.handleSingleFeatureSuccess,
  [actions.deleteAccount.failure.type]: actionsHandlers.handleSingleFeatureFailure,
  [actions.deleteAccount.reset.type]: actionsHandlers.handleSingleFeatureReset,
});

export default accountReducer;
